var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-loyalty"},[_c('img',{staticClass:"c-loyalty__icon",attrs:{"src":_vm.image,"alt":"Loyalty"}}),_c('div',{staticClass:"c-loyalty__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }